import { type ObjectValuesUnionType } from '../utils/typing';

export const SportIds = Object.freeze({
  SOCCER: 1,
  BASKETBALL: 2,
  BASEBALL: 3,
  ICEHOCKEY: 4,
  TENNIS: 5,
  HANDBALL: 6,
  FLOORBALL: 7,
  GOLF: 9,
  BOXING: 10,
  MOTOR_SPORT: 11,
  RUGBY: 12, // rugby à 15
  AUSSIE_RULES: 13,
  WINTER_SPORTS: 14,
  BANDY: 15,
  FOOTBALL: 16,
  CYCLING: 17,
  SPECIALS: 18,
  SNOOKER: 19,
  TABLE_TENNIS: 20,
  CRICKET: 21,
  DARTS: 22,
  VOLLEYBALL: 23,
  FIELD_HOCKEY: 24,
  POOL: 25,
  WATERPOLO: 26,
  CURLING: 28,
  FUTSAL: 29,
  OLYMPICS: 30,
  BADMINTON: 31,
  BOWLS: 32, // Boulingrin
  CHESS: 33,
  BEACH_VOLLEY: 34,
  ATHLETICS: 36,
  SQUASH: 37,
  LACROSSE: 39,
  FORMULA_1: 40,
  ALPINE: 43,
  BIATHLON: 44,
  BOBSLEIGH: 45,
  CROSS_COUNTRY: 46,
  NORDIC_COMBINED: 47,
  SKI_JUMPING: 48,
  SNOWBOARD: 49,
  SPEED_SKATING: 50,
  LUGE: 51,
  SWIMMING: 52,
  BEACH_SOCCER: 60,
  PESAPALLO: 61,
  ROWING: 64,
  PADEL: 71,
  ARCHERY: 75,
  EQUESTRIAN: 76,
  FENCING: 77,
  JUDO: 79,
  SAILING: 81,
  TRIATHLON: 84,
  WEIGHTLIFTING: 85,
  WRESTLING: 86,
  DIVING: 96,
  FIGURE_SKATING: 102,
  FREESTYLE_SKIING: 103,
  SKELETON: 104,
  SHORT_TRACK_SPEED_SKATING: 105,
  WORLD_LOTTERY: 108,
  ESPORT_COUNTER_STRIKE: 109,
  ESPORT_LEAGUE_OF_LEGENDS: 110,
  ESPORT_DOTA: 111,
  RUGBY_LEAGUE_OLD: 112,
  ESPORT_HEARTSTONE: 113,
  MMA: 117,
  ESPORT_COD: 118,
  ESPORT_OVERWATCH: 121,
  ESPORT_STREET_FIGHTER_V: 127,
  GAELICFOOTBALL: 135,
  GAELICHURLING: 136,
  ESPORT_SOCCER: 137,
  KABADDI: 138,
  ESPORT_PUBG: 140,
  ESPORT_BASKETBALL: 153,
  BASKETBALL_3: 155,
  ESPORT_TEKKEN: 156,
  ESPORT_SSBM: 160,
  ESPORT_ARTIFACT: 162,
  ESPORT_FORTNITE: 170,
  ESPORT_MOTOSPORT: 178,
  OPEN_WATER_SWIMMING: 182,
  SKATEBOARDING: 183,
  MOTO: 190,
  ESPORT_VALORANT: 194,
  ESPORT_ICE_HOCKEY: 195,
  RUGBY_7S_OLD: 212,
  RUGBY_7S: 9991, // rugby à 7
  RUGBY_LEAGUE: 9992, // rugby à 13
  SOCCER_7: 9993, // football à 7
  ESPORT: 9994,
  POLITICS: 99990,
  GAELICSPORT: 99995,
  NETBALL: 99996,
  SURF: 99997,
  PETANQUE: 99998,
  SPECIALS__99999: 99999,
  SPECIAL_ODDS: 100000,
  SPECIAL_ODD_TV: 100001,
});
export type SportId = ObjectValuesUnionType<typeof SportIds>;
